export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      work: "Success Stories",
      contact: "Contact",
    },
    hero: {
      tagline: "Expert Technology Consultant",
      title_top: "I Handle the Tech,",
      title_bottom: "So You Can Grow.",
      subtitle: "Reliable tech advisory and automation to help your business grow without the headaches.",
      cta: "Let's Talk",
    },
    about: {
      title: "Making Technology Work for You",
      p1: "I am a business growth partner with over 10 years of experience simplifying technology for companies of all sizes. I speak 'business,' not just 'code,' and I'm here to ensure your tools help you grow rather than hold you back.",
      p2: "I partner with business owners to stop the tech headaches, automate boring tasks, and make sure your systems are ready for the future. My goal is to give you peace of mind so you can focus on what you do best.",
    },
    services: {
      title: "Expert Strategic Services",
      items: [
        {
          title: "Your On-Demand Tech Advisor",
          description: "I help you make the right technology decisions for your business growth, without the complexity or the overhead.",
          icon: "🎯"
        },
        {
          title: "Technology Health Check",
          description: "Identifying why your systems are slow, unreliable, or costing too much, and providing a clear path to fix them.",
          icon: "🏗️"
        },
        {
          title: "Automating Your Busy Work",
          description: "Implementing simple but powerful tools to save you and your team hours by automating repetitive tasks.",
          icon: "🤖"
        },
        {
          title: "Safe Tech Modernization",
          description: "Moving your business to modern tools effortlessly, ensuring you stay ahead without the risk of breaking what works.",
          icon: "🚀"
        }
      ]
    },
    successStories: {
      title: "Strategic Impact",
      subtitle: "A track record of solving complex technical challenges and delivering high-value outcomes for global businesses.",
      skillsTitle: "Core Technical Expertise",
      engagementsTitle: "Selected Engagements",
      skills: [
        "Product Strategy & Definition",
        "Transforming Requirements into Robust Tech",
        "Strategic Software Architecture",
        "Tech on Demand & Rapid Prototyping",
        "AI-Driven Product Solutions",
        "Technical Mentorship & Leadership",
        "Cloud Engineering (AWS/GCP)",
        "Scalable Distributed Systems",
        "Agile Project Management",
        "Problem Solving & Optimization",
      ],
      experiences: [
        {
          company: "Elora",
          role: "Co-founder",
          start: "2024",
          industry: "Spiritual Growth",
          summary: [
            "Problem: Helping people build and maintain consistent spiritual habits in a busy, digital world.",
            "Solution: Development of a multi-platform mobile application that provides personalized daily spiritual plans and community engagement.",
            "Impact: Built a high-quality technical foundation for a spiritual-first product, enabling thousands to deepen their daily routines."
          ],
          tech: ["iOS (Swift/SwiftUI)", "Android (Kotlin)", "Product Strategy"],
          logoAlt: "Elora",
          link: "https://elorapp.com/",
        },
        {
          company: "Orbit Berry",
          role: "Co-founder",
          start: "2025",
          industry: "Marketing OS",
          summary: [
            "Problem: Social media management remains fragmented and time-consuming, making it hard for brands to scale content without losing their voice.",
            "Solution: Building an AI-powered 'Marketing OS' that unifies social operations, trend discovery, and automated smart publishing.",
            "Impact: Empowering marketing teams to scale content ops 10x using advanced AI automations and centralized workflows."
          ],
          tech: ["AI Integration", "Full-stack Engineering", "Social APIs"],
          logoAlt: "Orbit Berry",
          link: "https://www.producthunt.com/products/orbitberry",
        },
        {
          company: "dLocal",
          role: "Payments & AI",
          start: "Nov 2024",
          industry: "Fintech",
          summary: [
            "Problem: Ensuring secure and seamless payment verification in a fast-paced global enviornment.",
            "Solution: Optimized backend systems for fraud detection and KYC, making sure payments are handled safely and quickly.",
            "Impact: Reduced manual overhead and improved verification reliability for millions of transactions."
          ],
          tech: ["Java 17/21", "Spring Boot", "AWS", "Security Compliance"],
          logoAlt: "dLocal",
          logoSrc: "/logos/dlocal.png",
        },
        {
          company: "Glovo",
          role: "Growth & Scalability",
          start: "Nov 2022",
          end: "2024",
          industry: "Delivery Industry",
          summary: [
            "Problem: Scaling the platform for growth while maintaining high reliability and regulatory compliance.",
            "Solution: Designed growth features and platform-wide compliance layers. Conducted load testing for high-volume partners.",
            "Impact: Supported seamless international expansion and maintained 99.9% uptime during peak business growth."
          ],
          tech: ["Java", "Spring Boot", "Kafka", "AWS"],
          logoAlt: "Glovo",
          logoSrc: "/logos/glovo.png",
        },
        {
          company: "eDreams ODIGEO",
          role: "Data & Business Intelligence",
          start: "Oct 2016",
          end: "2022",
          industry: "Travel Industry",
          summary: [
            "Problem: Managing complex data flows across multiple engineering teams to inform business decisions.",
            "Solution: Built scalable data infrastructure and microservices to provide real-time business insights.",
            "Impact: Improved release velocity and enabled faster, data-driven decisions across the organization."
          ],
          tech: ["Java", "Google Cloud", "Kafka", "CI/CD"],
          logoAlt: "eDreams",
          logoSrc: "/logos/edreams.png",
        },
        {
          company: "everis",
          role: "Technical Consultant",
          start: "Oct 2016",
          end: "2016",
          industry: "Consultancy",
          summary: [
            "Problem: Supporting Europe's largest OTA with reliable, high-traffic travel booking systems.",
            "Solution: Delivered core infrastructure updates and managed distributed system reliability.",
            "Impact: Ensured a stable booking experience for millions of travelers."
          ],
          tech: ["Java", "Distributed Systems", "Agile"],
          logoAlt: "everis",
          logoSrc: "/logos/everis.png",
        },
        {
          company: "Altran",
          role: "Technical Analyst",
          start: "Feb 2016",
          end: "2016",
          industry: "Public Sector",
          summary: [
            "Problem: Transitioning outdated public sector systems to modern, reliable digital solutions.",
            "Solution: Led the design and backend implementation of critical digital services for the government.",
            "Impact: Modernized public infrastructure and improved the speed of government services."
          ],
          tech: ["Java", "Spring", "System Modernization"],
          logoAlt: "Altran",
          logoSrc: "/logos/altran.png",
        },
      ]
    },
    booking: {
      title: "Let's Book a Call",
      subtitle: "Interested in working together? Let's connect for 20 minutes to discuss your project, challenges, and how I can help you achieve your goals.",
      cta: "Book Discovery Call",
      imgAlt: "Book a Discovery Call",
    },
    contact: {
      title: "Message me",
      subtitle: "I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision. Reach me on LinkedIn or send me a message directly.",
      nameLabel: "Your Name",
      emailLabel: "Your Email",
      messageLabel: "Message",
      submitBtn: "Send Message",
      footer: "© {year} Javier Montero Palma. All rights reserved.",
    }
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Sobre Mí",
      services: "Servicios",
      work: "Casos de Éxito",
      contact: "Contacto",
    },
    hero: {
      tagline: "Consultoría Tecnológica",
      title_top: "Manejo la tecnología,",
      title_bottom: "para que tú puedas crecer.",
      subtitle: "Asesoría tecnológica y automatización para ayudar a que tu negocio crezca sin dolores de cabeza.",
      cta: "Hablemos",
    },
    about: {
      title: "Hago que la Tecnología Trabaje para Ti",
      p1: "Soy un socio estratégico para el crecimiento empresarial con más de 10 años de experiencia simplificando la tecnología para empresas de todos los tamaños. Hablo 'negocio', no solo 'código', y estoy aquí para asegurar que tus herramientas te ayuden a crecer en lugar de frenarte.",
      p2: "Me asocio con dueños de negocios para gestionar la tecnología, automatizar tareas aburridas y asegurar que tus sistemas estén listos para el futuro. Mi objetivo es darte tranquilidad para que puedas enfocarte en lo que mejor haces.",
    },
    services: {
      title: "Servicios Estratégicos",
      items: [
        {
          title: "Tu Asesor Tecnológico Bajo Demanda",
          description: "Te ayudo a tomar las decisiones tecnológicas correctas para el crecimiento de tu negocio, sin la complejidad ni los costos fijos.",
          icon: "🎯"
        },
        {
          title: "Chequeo de Salud Tecnológica",
          description: "Identificamos por qué tus sistemas son lentos, inestables o demasiado costosos, y trazamos un camino claro para solucionarlo.",
          icon: "🏗️"
        },
        {
          title: "Automatización de Tareas Repetitivas",
          description: "Implementación de herramientas simples pero potentes para ahorrarte a ti y a tu equipo horas mediante la automatización de tareas.",
          icon: "🤖"
        },
        {
          title: "Modernización Tecnológica Segura",
          description: "Migra tu negocio a herramientas modernas sin esfuerzo, asegurando que te mantengas a la vanguardia sin riesgo de romper lo que ya funciona.",
          icon: "🚀"
        }
      ]
    },
    successStories: {
      title: "Impacto Estratégico y Casos de Éxito",
      subtitle: "Una trayectoria resolviendo desafíos técnicos complejos y entregando resultados de alto valor para negocios globales.",
      skillsTitle: "Experiencia Técnica Principal",
      engagementsTitle: "Proyectos Seleccionados",
      skills: [
        "Estrategia y Definición de Producto",
        "Transformación de Requisitos en Tecnología Robusta",
        "Arquitectura de Software Estratégica",
        "Tecnología Bajo Demanda y Prototipado Rápido",
        "Soluciones de Producto Impulsadas por IA",
        "Mentoría y Liderazgo Técnico",
        "Ingeniería en la Nube (AWS/GCP)",
        "Sistemas Distribuidos Escalables",
        "Gestión de Proyectos Ágiles",
        "Resolución de Problemas y Optimización",
      ],
      experiences: [
        {
          company: "Elora",
          role: "Co-fundador",
          start: "2024",
          industry: "Crecimiento Espiritual",
          summary: [
            "Problema: Ayudar a las personas a construir y mantener hábitos espirituales constantes en un mundo digital acelerado.",
            "Solución: Desarrollo de una aplicación móvil multiplataforma que proporciona planes espirituales diarios personalizados y participación comunitaria.",
            "Impacto: Construcción de una base técnica de alta calidad para un producto espiritual, permitiendo a miles profundizar su fe."
          ],
          tech: ["iOS (Swift/SwiftUI)", "Android (Kotlin)", "Estrategia de Producto"],
          logoAlt: "Elora",
          link: "https://elorapp.com/",
        },
        {
          company: "Orbit Berry",
          role: "Co-fundador",
          start: "2025",
          industry: "S.O. de Marketing",
          summary: [
            "Problema: La gestión de redes sociales sigue fragmentada y consume tiempo, dificultando el escalado de contenido sin perder la esencia.",
            "Solución: Creación de un 'S.O. de Marketing' impulsado por IA que unifica procesos, descubrimiento de tendencias y publicación automatizada.",
            "Impacto: Empoderando a equipos de marketing para escalar operaciones x10 mediante automatizaciones de IA y flujos de trabajo centralizados."
          ],
          tech: ["Integración de IA", "Ingeniería Full-stack", "APIs de Redes Sociales"],
          logoAlt: "Orbit Berry",
          link: "https://www.producthunt.com/products/orbitberry",
        },
        {
          company: "dLocal",
          role: "Pagos e IA",
          start: "Nov 2024",
          industry: "Fintech",
          summary: [
            "Problema: Garantizar una verificación de pagos segura y fluida en un entorno global de ritmo rápido.",
            "Solución: Optimización de sistemas backend para detección de fraude y KYC, asegurando que los pagos se manejen de forma segura y rápida.",
            "Impacto: Reducción significativa de la carga de verificación manual y aumento de la confiabilidad del sistema para millones de transacciones."
          ],
          tech: ["Java 17/21", "Spring Boot", "AWS", "Cumplimiento de Seguridad"],
          logoAlt: "dLocal",
          logoSrc: "/logos/dlocal.png",
        },
        {
          company: "Glovo",
          role: "Crecimiento y Escalabilidad",
          start: "Nov 2022",
          end: "2024",
          industry: "Servicios de Entrega",
          summary: [
            "Problema: Escalar la plataforma para el crecimiento manteniendo una alta confiabilidad y cumplimiento normativo.",
            "Solución: Diseño de funciones de crecimiento y capas de cumplimiento a nivel de plataforma. Pruebas de carga para socios de gran volumen.",
            "Impacto: Expansión internacional fluida y mantenimiento de un tiempo de actividad del 99.9% durante picos de crecimiento."
          ],
          tech: ["Java", "Spring Boot", "Kafka", "AWS"],
          logoAlt: "Glovo",
          logoSrc: "/logos/glovo.png",
        },
        {
          company: "eDreams ODIGEO",
          role: "Datos e Inteligencia de Negocios",
          start: "Oct 2019  ",
          end: "Nov 2022",
          industry: "Industria de Viajes",
          summary: [
            "Problema: Gestión de flujos de datos complejos entre múltiples equipos de ingeniería para informar decisiones de negocio.",
            "Solución: Construcción de infraestructura de datos escalable y microservicios para proporcionar información de negocio en tiempo real.",
            "Impacto: Aceleración de la velocidad de lanzamiento y toma de decisiones basada en datos en toda la organización."
          ],
          tech: ["Java", "Google Cloud", "Kafka", "CI/CD"],
          logoAlt: "eDreams",
          logoSrc: "/logos/edreams.png",
        },
        {
          company: "everis",
          role: "Consultor Técnico",
          start: "Oct 2016",
          end: "Oct 2019",
          industry: "Consultoría",
          summary: [
            "Problema: Soporte a una de las agencias de viajes online más grandes de Europa con sistemas de reserva de alto tráfico.",
            "Solución: Entrega de actualizaciones de infraestructura central y gestión de la confiabilidad de sistemas distribuidos.",
            "Impacto: Garantía de una experiencia de reserva estable para millones de viajeros."
          ],
          tech: ["Java", "Sistemas Distribuidos", "Agile"],
          logoAlt: "everis",
          logoSrc: "/logos/everis.png",
        },
        {
          company: "Altran",
          role: "Analista Técnico",
          start: "Feb 2016",
          end: "Oct 2016",
          industry: "Sector Público",
          summary: [
            "Problema: Transición de sistemas obsoletos del sector público a soluciones digitales modernas y confiables.",
            "Solución: Liderazgo en el diseño e implementación backend de servicios digitales críticos para el gobierno.",
            "Impacto: Modernización de la infraestructura pública y mejora en la velocidad de los servicios gubernamentales."
          ],
          tech: ["Java", "Spring", "Modernización de Sistemas"],
          logoAlt: "Altran",
          logoSrc: "/logos/altran.png",
        },
      ]
    },
    booking: {
      title: "Reserva una Llamada",
      subtitle: "¿Interesado en trabajar juntos? Conectemos durante 20 minutos para discutir tu proyecto, desafíos y cómo puedo ayudarte a alcanzar tus objetivos.",
      cta: "Reservar Llamada de Descubrimiento",
      imgAlt: "Reservar una Llamada de Descubrimiento",
    },
    contact: {
      title: "Trabajemos Juntos",
      subtitle: "Siempre estoy abierto a discutir nuevos proyectos, ideas creativas u oportunidades para ser parte de tu visión. Contáctame por LinkedIn o envíame un mensaje directo.",
      nameLabel: "Tu Nombre",
      emailLabel: "Tu Email",
      messageLabel: "Mensaje",
      submitBtn: "Enviar Mensaje",
      footer: "© {year} Javier Montero Palma. Todos los derechos reservados.",
    }
  }
};
